import React, { useState } from 'react';
import Box, { Header, IconBox } from './Box';
import { useMutation } from '@apollo/client';
import { M_REQUEST_EMAIL_CONFIRMATION } from '../../graphql/user';
import { IRequestVerifyEmail } from '../../types/user';
import SmallLoadingDots from '../base/SmallLoadingDots';
import { PrismicAccountStatus } from '../../types/prismic';

type Props = {
  userId: string;
  email: string;
  isEmailVerified: boolean;
  content: PrismicAccountStatus;
};

type BoxProps = {
  href?: string;
  onClick?: (e: React.MouseEvent) => void;
};

const AccountStatus = ({ userId, email, isEmailVerified, content }: Props) => {
  const [verifyEmailSent, setVerifyEmailSent] = useState(false);

  const resendVerifyEmail = async (e: React.MouseEvent) => {
    e.preventDefault();

    await requestEmailConfirmation({
      variables: {
        email,
      },
    });
  };

  const [
    requestEmailConfirmation,
    { loading, error },
  ] = useMutation<IRequestVerifyEmail>(M_REQUEST_EMAIL_CONFIRMATION, {
    onCompleted() {
      setVerifyEmailSent(true);
    },
    onError(error: any) {
      console.error('Error:', error.message);
    },
  });

  let boxProps = {} as BoxProps;
  if (userId && isEmailVerified) boxProps.href = `/profile/${userId}`;
  if (!isEmailVerified) boxProps.onClick = resendVerifyEmail;

  return (
    <Box {...boxProps}>
      <IconBox>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38.147"
          height="38.147"
          viewBox="0 0 38.147 38.147"
        >
          <path
            id="np_profile_922825_000000"
            d="M34.574,15.5A19.074,19.074,0,1,0,53.647,34.574,19.112,19.112,0,0,0,34.574,15.5Zm0,36.489a17.2,17.2,0,0,1-12.329-5.142c3.373-4.533,7.74-7.021,12.329-7.021S43.53,42.314,46.9,46.847A17.2,17.2,0,0,1,34.574,51.989Zm0-14.374a6.3,6.3,0,1,1,6.3-6.3A6.3,6.3,0,0,1,34.574,37.614Zm13.435,8.017a17.882,17.882,0,0,0-10.118-7.077A7.963,7.963,0,1,0,26.614,31.31a8.045,8.045,0,0,0,4.643,7.244,18.046,18.046,0,0,0-10.118,7.021,17.229,17.229,0,0,1-3.98-11.057,17.415,17.415,0,1,1,30.85,11.114Z"
            transform="translate(-15.5 -15.5)"
            fill="#ab5742"
          />
        </svg>
      </IconBox>
      <Header>{content.data.account_status_header}</Header>
      {isEmailVerified && !loading && (
        <p>{content.data.account_status_update_details}</p>
      )}
      {!isEmailVerified && loading && (
        <p>
          <SmallLoadingDots />
        </p>
      )}
      {verifyEmailSent && !loading && (
        <p>{content.data.account_status_sent_verification}</p>
      )}
      {!verifyEmailSent && !isEmailVerified && !loading && (
        <p>
          {content.data.account_status_please_verify}{" "}
          <u>{content.data.account_status_please_verify_call_to_action}</u>
        </p>
      )}
    </Box>
  );
};

export default AccountStatus;
